import { ENTRY_STEP_ID } from '@/shared/config/funnel/flowConstants';
import type { AnswerAction } from './actions';
import type { AnswerStore } from './types';

export const initialAnswerStore: AnswerStore = {
  answers: {},
  submittedAnswers: {},
  isHydrated: false,
  shouldSkipRecommendations: false,
};

export function reducer(state: AnswerStore, action: AnswerAction): AnswerStore {
  switch (action.type) {
    case 'HYDRATE': {
      const answers = { ...action.answers };
      // Sets branch if user directly accessed the first step
      if (action.branchId && answers[ENTRY_STEP_ID] === undefined) {
        answers[ENTRY_STEP_ID] = action.branchId;
      }
      return {
        answers,
        submittedAnswers: answers,
        isHydrated: true,
        shouldSkipRecommendations: Object.keys(answers).length < 2,
      };
    }
    case 'DEHYDRATE':
      return {
        ...state,
        isHydrated: false,
      };
    case 'RESET_BRANCH': {
      const branchId = action.branchId;
      const answers = { [ENTRY_STEP_ID]: branchId };
      return {
        ...state,
        answers,
        submittedAnswers: answers,
      };
    }
    case 'SET_ANSWER':
      return {
        ...state,
        answers: { ...state.answers, [action.stepId]: action.value },
      };
    case 'SUBMIT_ANSWER':
      return {
        ...state,
        answers: { ...state.answers, [action.stepId]: action.value },
        submittedAnswers: { ...state.submittedAnswers, [action.stepId]: action.value },
        shouldSkipRecommendations: Object.keys(state.answers).length < 2,
      };
    case 'CLEAR_ANSWER': {
      const answers = { ...state.answers };
      const submittedAnswers = { ...state.submittedAnswers };
      delete answers[action.stepId];
      delete submittedAnswers[action.stepId];
      return { ...state, answers, submittedAnswers };
    }
    case 'RESET_ANSWERS': {
      // Keep isHydrated true so session sync does not re-read storage and
      // re-trigger landing redirects while navigation is in flight.
      if (
        state.isHydrated &&
        Object.keys(state.answers).length === 0 &&
        Object.keys(state.submittedAnswers).length === 0
      ) {
        return state;
      }
      return {
        ...initialAnswerStore,
        isHydrated: true,
      };
    }
  }
}
